<template>
  <div>
    <filter-data
      with_client_portfolios
      with_text_search
      :with_client="false"
      :with_date_start="false"
      :with_date_end="false"
      @doneFilter="handleDoneFilter"
    />
    <returned-checks-table
      kind="to_confirm" 
      :items="allReturnedChecks" 
      :table-search="tableSearch"
      :loading="loading" 
      :headers="headers" 
      @doneStatus="handleDoneUpdate" 
      @doneUpdate="handleDoneUpdate"
      @doneDelete="handleDoneUpdate"
    ></returned-checks-table>
  </div>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex'

export default {
  name: 'ReturnedChecksToConfirm',
  inject: {
    registerReturnedChecksListReload: {
      default: () => () => {},
    },
  },
  components: {
    ReturnedChecksTable: () => import('./shared/ReturnedChecksTable'),
    FilterData: () => import('@/components/shared/FilterData.vue'),
  },
  data() {
    return {
      headers: [
        { text: '#', value: 'attributes.id', align: 'center' },
        { text: 'Cliente', value: 'attributes.client_name', align: 'center' },
        { text: 'Número', value: 'attributes.number', align: 'center' },
        { text: 'Motivo', value: 'attributes.motive', align: 'center' },
        { text: 'Valor (R$)', value: 'attributes.value', align: 'center' },
        { text: 'Comentário', value: 'attributes.comment', align: 'center', sortable: false },
        {text: 'Detalhes',  value: 'details', sortable: false},
        {text: 'Módulo', value: 'attributes.place_name'},
        {text: 'Ações', value: 'actions', sortable: false}
      ],
      loading: false,
      local_filter: {},
    }
  },

  computed: {
    tableSearch() {
      return (this.local_filter && this.local_filter.query) ? String(this.local_filter.query) : ''
    },
    ...mapState({
      allReturnedChecks: state => state.ReturnedCheck.allReturnedChecks,
    }),
  },
  methods: {
    handleDoneFilter(e){
      this.local_filter = { ...e }
      this.getReturnedChecks()
    },
    handleDoneUpdate(){
      this.getReturnedChecks()
    },
    getReturnedChecks() {
      let filters = {
        by_place_ids: [this.activeModalityId],
        by_statuses: ['to_confirm'],
        ...this.local_filter,
      }

      this.$emit('doneFilter', {...filters} )

      this.loading = true
      if (this.activeModalityId){
        this.indexReturnedChecks(filters).finally(()=>{
          this.loading = false
        })
      }
    },
    ...mapActions({
      indexReturnedChecks: 'ReturnedCheck/index'
    })
  },
  mounted () {
    this.getReturnedChecks()
    this.registerReturnedChecksListReload(this.getReturnedChecks)
  },
  beforeDestroy() {
    this.registerReturnedChecksListReload(null)
  },
  watch: {
    activeModalityId() {
      this.getReturnedChecks()
    },
  }
}
</script>
